<!-- 科四顺序 -->
<template>
    <div class="posre">
        <Header :Logo="logo" :city="cityName" :Link="link" :TitleList="titleList" :Color="color" :img="bgImg"></Header>
        <div class="w100p">
            <div class="w1200 mauto pt50 pb50 overflow">
                <div class=" disinblock w68p floatl">
                     <p class="fs30 c333">2020年小车科目四试题</p>
                    <div class="fs26 c333 mt20">
                        <span class="fs14 c999 mr16" v-if="practice.e_typeX==1">单选题</span>
                        <span class="fs14 c999 mr16" v-if="practice.e_typeX==2">多选题</span>
                        <span class="fs14 c999 mr16" v-if="practice.e_typeX==3">判断题</span>
                        <p class="cursor alit mt25 mb25 borther answerParent ">
                            <!-- {{practice.exercise_id}}、 -->
                            {{practice.title}}
                        </p>
                        
                        <div class="fs26 c333 mt20" v-if="practice.e_typeX==2">
                            <!-- 多选 -->
                            <p :class="{'aaaaa':once==1}" v-for="(item,index) in choose_listX" :key="index"
                                @click="choose22(item.chose,practice.answer,$event,practice.exercise_id,practice,index)"
                                class="cursor alit mt15 mb15 borther " ref="answerParent">
                                <!-- <img class="w30 h30 answerImg" :src="answerImg" alt="" ref="answerImg"> -->
                        
                                <img v-if="item.T==0" class="w30 h30" src="../../public/img/img68.png" alt="" ref="answerImg">
                                <img v-if="item.T==1" class="w30 h30" src="../../public/img/img67.png" alt="" ref="answerImg">
                                <img v-if="item.T==2" class="w30 h30" src="../../public/img/img69.png" alt="" ref="answerImg">
                                <img v-if="item.T==3" class="w30 h30" src="../../public/img/img116.png" alt="" ref="answerImg">
                                <span class="disinblock ml16 " ref="answerParent111"> {{item.chose}} </span>
                            </p>
                            <div class="fs16 mt10 mb10">
                                <span @click="sentChoose(practice.answer)" class="fs20 cursor disinblock textc c666 bg1f8 pl6 pr16 cfff pt5 pb5 bradius8">确定</span>
                            </div>
                        </div>
                        <div class="fs26 c333 mt20" v-else>
                            <!-- 单选 -->
                            <p :class="{'aaaaa':once==1}"  v-for="(item,index) in choose_listX" :key="index"
                                @click="choose(item.chose,practice.answer,$event,practice.exercise_id,practice,index)"
                                class="cursor alit mt15 mb15 borther " ref="answerParent">
                                <!-- <img class="w30 h30 answerImg" :src="answerImg" alt="" ref="answerImg"> -->
                            
                                <img v-if="item.T==0" class="w30 h30" src="../../public/img/img68.png" alt="" ref="answerImg">
                                <img v-if="item.T==1" class="w30 h30" src="../../public/img/img67.png" alt="" ref="answerImg">
                                <img v-if="item.T==2" class="w30 h30" src="../../public/img/img69.png" alt="" ref="answerImg">
                                <span class="disinblock ml16"> {{item.chose}} </span>
                            </p>
                        </div>
                        <div class="fs16" v-if="noteShow==1">
                            {{practice.note}}
                        </div>
                        <div v-if="practice.image  && practice.img_type==1" class="pl16 pr16 pt20 pb20">
                            <img class="w300 hauto bradius8 " :src="practice.image " alt="">
                        </div>

                        <video  autoplay="autoplay" v-if="practice.image && practice.img_type==2"  controls controlslist="nodownload" preload="none" width="320" height="240"
                        :src="practice.image">
                        </video>


                        <div class="pt8 pb8 w100p overhidden">
                            <p class="overhidden  mauto">
                                <span @click="last()"
                                    class="border2e bradius25 fs20 cfff  bg1f8  floatl mr20 pl30 pr30 pt12 pb12 cursor">上一题</span>
                                <span @click="next()"
                                    class="border2e bradius25 fs20 disinblock floatl ml20 pl30 pr30 pt12 pb12 cfff bg1f8 cursor">下一题</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import $ from "jquery";
    export default {
        data() {
            return {
                color: 1,
                link: 2,
                titleList: 4,
                logo: 'home',
                cityName: '',
                bgImg: require('../../public/img/img51.png'),
                schoolList2: [],
                index: 0,
                practice: { //练习题
                    title: '',
                    e_typeX: 1,
                    answer: '', //正确答案
                    image: '',
                    exercise_id: '', //题号
                    img_type: 1,
                    note: ''
                },
                choose_listX: [], //选项
                practiceList: [],
                chooseList: [],
                typeIndex: 0,
                answerImg: require('../../public/img/img68.png'),
                once: 0,
                Already: [],
                markList: [],
                noteShow: 0,
                pointImg: ''
            };
        },
        components: {
            Header,
            Footer,
        },
        methods: {
            getPractice() {
                let that = this;
                $.ajax({
                    type: "POST",
                    url: that.beseAjax + "/getSubjects.do",
                    dataType: "json",
                    async: false,
                    data: {
                        "km_type": 4,
                        "order": 0
                    },
                    success: function(data) {
                        let typeIndex = that.typeIndex;
                        that.practice = data.obj[typeIndex];
                        that.practiceList = data.obj;
                        that.practice.image = data.obj[typeIndex].image;
                        that.practice.answer = data.obj[typeIndex].answer;
                        that.practice.e_typeX = data.obj[typeIndex].e_type;
                        that.practice.note = data.obj[typeIndex].note;
                        let markX = {
                            item: '',
                            index: '',
                            index1: '',
                            answer: '',
                            answerFR: -1,

                        };
                        let arr2 = data.obj[typeIndex].choose_list.split("|");
                        for (let i = 0; i < arr2.length; i++) {
                            let P = {
                                chose: arr2[i],
                                T: 0
                            }
                            that.choose_listX.push(P);
                            that.markList.push(markX)
                        }


                    },
                    error: function(data) {
                        console.log(data);
                    }
                });
            },
            next() {
                let that = this;
                if (that.practiceList.length != that.typeIndex + 1) {
                    that.typeIndex++;
                    that.Judgment();
                } else {
                    alert('这已经是最后一题了')
                }

            },
            last() {
                let that = this;

                if (that.typeIndex == 0) {
                    alert('这已经是第一题了')
                } else {
                    that.typeIndex--;
                    that.Judgment();
                    // that.e_typeX = that.practiceList[that.typeIndex].e_type
                }
            },
            Judgment() {
                let that = this;
                that.noteShow = 0;
                that.practice = that.practiceList[that.typeIndex];
                that.practice.e_typeX = that.practiceList[that.typeIndex].e_type;
                that.practice.image = that.practiceList[that.typeIndex].image;
                // that.videosrc = that.practiceList[that.typeIndex].image;
                console.log(that.practice.image)
                let getAlready = that.$store.state.chooseList3;
                let arr2 = that.practice.choose_list.split("|");

                that.choose_listX = []
                that.markList = []
                let markX = {
                    item: '',
                    index: '',
                    index1: '',
                    answer: '',
                    answerFR: -1,

                };
                for (let i = 0; i < arr2.length; i++) {
                    let P = {
                        chose: arr2[i],
                        T: 0
                    }
                    that.choose_listX.push(P)
                    that.markList.push(markX)
                }

                if (that.practice.e_typeX == 1 || that.practice.e_typeX == 3) {
                    for (let i = 0; i < getAlready.length; i++) {
                        if (getAlready[i].index == that.practice.exercise_id) { //getAlready[i].index做了的题
                            if (getAlready[i].rigthFalse == true) {
                                that.once = 1;
                                console.log('对');
                                that.noteShow = 1
                                    //item我选的那道题选项
                                    //index1我选的那道题下标
                                let P = {
                                    chose: that.choose_listX[getAlready[i].index1].chose,
                                    T: 1
                                }
                                that.choose_listX.splice(getAlready[i].index1, 1, P)
                            } else {
                                let j = getAlready[i].index1;
                                console.log('错误');
                                that.noteShow = 1
                                    //循环选项
                                let itemX = that.practice.choose_list;

                                let P = {
                                    chose: that.choose_listX[j].chose,
                                    T: 2
                                }
                                that.choose_listX.splice(j, 1, P)
                                for (let jj = 0; jj < arr2.length; jj++) {
                                    // console.log(getAlready[i]);
                                    if (arr2[jj].indexOf(getAlready[i].answer) != -1) {
                                        let P = {
                                            chose: that.choose_listX[jj].chose,
                                            T: 1
                                        }
                                        that.choose_listX.splice(jj, 1, P)
                                            //that.$refs.answerImg[jj].src = require('../../public/img/img67.png');
                                    }
                                }

                                that.T = 2;
                                //that.$refs.answerImg[j].src = require('../../public/img/img69.png');
                            }
                            that.once = 1;
                            return;
                        } else {
                            that.once = 0;
                        }
                    }
                    if (that.once == 0) {
                        let mark1 = {
                            item: '',
                            index: '',
                            index1: '',
                            rigthFalse: '',
                            answer: ''
                        };
                        if (that.typeIndex == getAlready.length) {
                            // that.Already.splice(index - 1, 1, mark)
                            that.Already.push(mark1)
                        }
                        that.$forceUpdate()
                        that.$store.dispatch('asyncInrement3').then(() => {
                            that.$store.state.chooseList3 = that.Already;
                        });
                    }
                } else if (that.practice.e_typeX == 2) {
                    that.once = 0;
                    let getL = getAlready[that.typeIndex];
                    console.log(getAlready)
                    console.log(that.typeIndex)


                    if (getL) {
                        console.log(getAlready)
                        console.log(getL)
                        that.noteShow = 1;
                        if (getL.isDo == 1) {
                            for (let i = 0; i < getL.list.length; i++) {
                                let Answer = that.practice.answer.split("|");
                                if (getL.list[i].answerFR == 1) {
                                    let P = {
                                        chose: that.choose_listX[getL.list[i].index1].chose,
                                        T: 1
                                    };
                                    that.choose_listX.splice(getL.list[i].index1, 1, P);
                                    that.once = 1;
                                } else if (getL.list[i].answerFR == 0) {
                                    let P = {
                                        chose: that.choose_listX[getL.list[i].index1].chose,
                                        T: 2
                                    };
                                    that.choose_listX.splice(getL.list[i].index1, 1, P);
                                    that.once = 1;
                                } else if (getL.list[i].answerFR == -1) {
                                    for (let j = 0; j < Answer.length; j++) {
                                        if (that.choose_listX[i].chose.indexOf(Answer[j]) != -1) {
                                            let P = {
                                                chose: that.choose_listX[i].chose,
                                                T: 3
                                            };
                                            that.choose_listX.splice(i, 1, P);
                                            break;
                                            // return;
                                        } else {
                                            let P = {
                                                chose: that.choose_listX[i].chose,
                                                T: 0
                                            };
                                            that.choose_listX.splice(i, 1, P);
                                        }

                                    }
                                }
                            }
                        }
                    }
                    if (that.once == 0) {
                        let mark2 = {
                            list: [{
                                item: '',
                                index: '',
                                index1: '',
                                answer: '',
                                answerFR: -1
                            }],
                            isDo: 0
                        }

                        if (that.typeIndex == getAlready.length) {
                            that.Already.push(mark2)

                        }
                        that.$forceUpdate()
                        that.$store.dispatch('asyncInrement3').then(() => {
                            that.$store.state.chooseList3 = that.Already;
                        });
                    }
                }

            },

            choose(item, answer, e, index, practice, index1) {
                let that = this;
                let rigth = '';
                that.once = 1;
                that.noteShow = 1
                if (item.indexOf(answer) != -1) {
                    let P = {
                        chose: that.choose_listX[index1].chose,
                        T: 1
                    }
                    that.choose_listX.splice(index1, 1, P)
                    rigth = true;
                } else {
                    let P = {
                        chose: that.choose_listX[index1].chose,
                        T: 2
                    }
                    that.choose_listX.splice(index1, 1, P)
                    for (let i = 0; i < that.choose_listX.length; i++) {
                        if (that.choose_listX[i].chose.indexOf(answer) != -1) {
                            let P = {
                                chose: that.choose_listX[i].chose,
                                T: 1
                            }
                            that.choose_listX.splice(i, 1, P)
                        }
                    }
                    rigth = false;
                }
                let mark = {
                    item: item,
                    index: index,
                    index1: index1,
                    rigthFalse: rigth,
                    answer: answer,
                };

                let getAlready = that.$store.state.chooseList3; //取vuex缓存'

                if (getAlready.length == 0) {
                    that.Already.push(mark)
                } else {
                    that.Already.splice(that.typeIndex, 1, mark)
                }
                that.$forceUpdate()
                that.$store.dispatch('asyncInrement3').then(() => {
                    that.$store.state.chooseList3 = that.Already;
                });
            },
            choose22(item, answer, e, index, practice, index1) {
                let that = this;
                let TT = that.choose_listX[index1].T; //所有选项
                let Answer = answer.split("|");
                let answerFR = ''

                for (let i = 0; i < Answer.length; i++) {
                    if (item.indexOf(Answer[i]) != -1) {
                        answerFR = 1;
                        break;
                    } else {
                        answerFR = 0;
                    }
                }

                let markX = {
                    item: item,
                    index: index,
                    index1: index1,
                    answer: answer,
                    answerFR: answerFR
                }
                let markX1 = {
                    item: '',
                    index: '',
                    index1: '',
                    answer: '',
                    answerFR: -1
                };

                if (TT == 1) {
                    let P = {
                        chose: that.choose_listX[index1].chose,
                        T: 0
                    }
                    that.choose_listX.splice(index1, 1, P);
                    that.markList.splice(index1, 1, markX1)
                } else {
                    let P = {
                        chose: that.choose_listX[index1].chose,
                        T: 1
                    }
                    that.choose_listX.splice(index1, 1, P);
                    // that.markList.push(markX)
                    that.markList.splice(index1, 1, markX)
                }
                let getAlready = that.$store.state.chooseList3; //取vuex缓存'


            },
            sentChoose(Answer) {
                let that = this;

                //  let mark = that.markList;
                let answer = Answer.split("|");
                let a = 0;
                for (let i = 0; i < that.markList.length; i++) {
                    if (that.markList[i].answerFR != -1) {
                        a = 1;
                        break;
                    }
                }
                if (a == 0) {
                    alert('请选择题目');
                    return;
                }
                that.noteShow = 1
                that.once = 1;
                let mark2 = {
                    list: that.markList,
                    isDo: 1
                }
                let getAlready = that.$store.state.chooseList3; //取vuex缓存'
                that.Already.splice(that.typeIndex, 1, mark2)
                that.$forceUpdate()
                that.$store.dispatch('asyncInrement3').then(() => {
                    that.$store.state.chooseList3 = that.Already;
                });
                for (let i = 0; i < that.markList.length; i++) {
                    if (that.markList[i].answerFR == 1) {
                        let P = {
                            chose: that.choose_listX[that.markList[i].index1].chose,
                            T: 1
                        };
                        that.choose_listX.splice(that.markList[i].index1, 1, P);
                        console.log(1)
                    } else if (that.markList[i].answerFR == 0) {
                        let P = {
                            chose: that.choose_listX[that.markList[i].index1].chose,
                            T: 2
                        };
                        that.choose_listX.splice(that.markList[i].index1, 1, P);
                        console.log(2)
                    } else if (that.markList[i].answerFR == -1) {
                        for (let j = 0; j < answer.length; j++) {
                            if (that.choose_listX[i].chose.indexOf(answer[j]) != -1) {
                                let P = {
                                    chose: that.choose_listX[i].chose,
                                    T: 3
                                };
                                that.choose_listX.splice(i, 1, P);
                                //return;
                                break;
                            }

                        }
                    }
                }


            },
            tiku() {
                let tiku = this.$route.query.tiku
                this.typeIndex = tiku;
            }
        },


        created() {
            let that = this;
            this.tiku();
            this.getPractice();
            // this.Judgment();
            this.cityName = this.$store.state.cityName;
            console.log(111111)
            console.log(this.cityName)
        },

        mounted() {
            let that = this;
            that.Already = that.$store.state.chooseList3;
            if (window.performance.navigation.type == 1) {
                console.log("页面被刷新")

                that.$forceUpdate()
                that.$store.dispatch('asyncInrement3').then(() => {
                    that.$store.state.chooseList3 = that.Already;
                });

            }
            if (that.Already.length < that.typeIndex) {
                let a = that.typeIndex - that.Already.length;
                for (let i = 0; i < a; i++) {
                    let mark2 = {
                        list: [{
                            item: '',
                            index: '',
                            index1: '',
                            answer: '',
                            answerFR: -1
                        }],
                        isDo: 0
                    }
                    that.Already.push(mark2)
                    that.$forceUpdate()
                    that.$store.dispatch('asyncInrement3').then(() => {
                        that.$store.state.chooseList3 = that.Already;
                    });
                }
            }
        }
    }
</script>
<style scoped>
    .aaaaa {
        pointer-events: none;
    }
</style>